export enum CampaignTab {
  Leads = 'leads',
  Opportunities = 'opptys',
  Deals = 'deals',
}
